import { useState } from 'react';
import { carti } from '../assets/Carti';
import { Download, Filter, User, Tag, Book } from 'lucide-react';

export default function CartiSection() {
  const [categorieSelectata, setCategorieSelectata] = useState('Toate');

  const categorii = ['Toate', ...new Set(carti.map(carte => carte.categorie))];

  const cartiFiltrate = categorieSelectata === 'Toate'
    ? carti
    : carti.filter(carte => carte.categorie === categorieSelectata);

  return (
    <section style={{ paddingBottom: '32px' }}>
      
      {/* Container Filtrare */}
      <div
        style={{
          marginBottom: '32px',
          padding: '20px',
          background: '#1e293b', // Slate 800
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.05)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          maxWidth: '500px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
        }}
      >
        <label
          htmlFor="filtru-categorie"
          style={{
            fontWeight: 600,
            fontSize: '1rem',
            color: '#cbd5e1',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <Filter size={18} color="#fbbf24" /> Filtrează:
        </label>
        <select
          id="filtru-categorie"
          value={categorieSelectata}
          onChange={(e) => setCategorieSelectata(e.target.value)}
          style={{
            fontSize: '0.95rem',
            padding: '10px 16px',
            borderRadius: '12px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            background: '#0f172a',
            color: '#f8fafc',
            fontWeight: 500,
            outline: 'none',
            cursor: 'pointer',
            transition: 'border 0.2s',
            width: '100%',
          }}
          onFocus={(e) => e.target.style.borderColor = '#fbbf24'}
          onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
        >
          {categorii.map((cat, idx) => (
            <option key={idx} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      {/* Grid-ul Cărților */}
      <div
        style={{
          display: 'grid',
          gap: '24px',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))'
        }}
      >
        {cartiFiltrate.map((carte, idx) => (
          <div
            key={idx}
            style={{
              background: '#1e293b',
              padding: '24px',
              borderRadius: '20px',
              border: '1px solid rgba(255, 255, 255, 0.05)',
              boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minHeight: '300px',
              transition: 'transform 0.2s ease',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-4px)"}
            onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
          >
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: '1.25rem',
                  marginBottom: '16px',
                  color: '#f8fafc',
                  lineHeight: '1.3'
                }}
              >
                {carte.titlu}
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
                <div style={{ color: '#cbd5e1', fontSize: '0.95rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <User size={16} color="#fbbf24" /> Autor: {carte.autor || 'Necunoscut'}
                </div>
                <div style={{ color: '#94a3b8', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Book size={16} color="#fbbf24" /> {carte.type}, {carte.pagini} pagini
                </div>
                <div style={{ color: '#94a3b8', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Tag size={16} color="#fbbf24" /> Categorie: <span style={{ color: '#e2e8f0', fontWeight: 600 }}>{carte.categorie}</span>
                </div>
              </div>
            </div>

            <a
              href={carte.url}
              download
              style={{
                backgroundColor: '#fbbf24',
                color: '#0f172a',
                fontWeight: 700,
                padding: '12px 16px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                textDecoration: 'none',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f59e0b'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fbbf24'}
            >
              <Download size={18} strokeWidth={2.5} /> Descarcă Fișierul
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
